import React from 'react';
import { TermsContent } from '../components/legal/TermsContent';

export const TermsPage = () => {
  return (
    <main className="min-h-screen bg-jp-page text-jp-ink text-left overflow-x-hidden">
      {/* Navy strip behind the see-through navbar so its white logo and links stay readable */}
      <div className="bg-jp-band h-16 sm:h-20" aria-hidden="true" />

      <section className="px-4 sm:px-6 lg:px-8 pt-14 sm:pt-20 pb-16 sm:pb-20">
        <div className="max-w-2xl mx-auto text-center mb-8">
          <p className="text-jp-accent dark:text-jp-gold text-sm font-bold uppercase tracking-widest mb-3">
            Legal
          </p>
          <h1 className="text-5xl sm:text-6xl font-anton leading-[1.1] tracking-tight text-jp-ink">
            TERMS OF SERVICE
          </h1>
          <p className="mt-4 text-jp-muted text-sm sm:text-base">Effective Date: 01-July-2026</p>
        </div>

        <div className="max-w-4xl mx-auto bg-jp-card rounded-2xl border border-jp-outline/70 shadow-sm p-5 sm:p-8">
          <div className="rounded-xl p-6 sm:p-10 bg-jp-section border border-jp-outline/50">
            <TermsContent />
          </div>
        </div>
      </section>
    </main>
  );
};

export default TermsPage;
